import { createFileRoute } from '@tanstack/react-router';
import { Portfolio } from '../features/portfolio';
import { Stack } from '@mui/material';
import { createPageBackgroundSx } from '../styles/pageBackground';

export const Route = createFileRoute('/portfolio')({
  component: PortfolioPage,
});

const portfolioPageSx = createPageBackgroundSx();

function PortfolioPage() {
  return (
    <Stack sx={portfolioPageSx}>
      <Portfolio></Portfolio>
    </Stack>
  );
}
